var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashBoardicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 13.25H10.75V0.75H0.75V13.25ZM0.75 23.25H10.75V15.75H0.75V23.25ZM13.25 23.25H23.25V10.75H13.25V23.25ZM13.25 0.75V8.25H23.25V0.75H13.25Z",
    fill: "#311A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashBoardicon);
export default __webpack_public_path__ + "static/media/dashBoardicon.f2f761336622326b8812aaa0bbf999f6.svg";
export { ForwardRef as ReactComponent };